import { VIEWPORT_COLUMN } from "../../../constants/Constants";

export const isSeriesValid = (viewportSeriesData, isReferenceLineEnabled, studyId, viewportRow, viewportColumn) => {
    if (isReferenceLineEnabled) {

        for (let i = 0; i < viewportSeriesData.length; i++) {
            const data = viewportSeriesData[i];
            if (data.study != "" && data?.study != studyId && ((i / VIEWPORT_COLUMN < viewportRow &&
                i % VIEWPORT_COLUMN < viewportColumn))) return false;
        }

        return true;

    } else {
        return true;
    }
}

export const canReferenceLinesBeEnabled = (viewportSeriesData, viewportRow, viewportColumn) => {
    const study = viewportSeriesData[0].study;

    for (let i = 1; i < viewportSeriesData.length; i++) {
        const data = viewportSeriesData[i]
        if (data.study != "" && data?.study != study && ((i / VIEWPORT_COLUMN < viewportRow &&
        i % VIEWPORT_COLUMN < viewportColumn))) return false;
    }

    return true;
}